import { ErrorIcon } from '@components/Icons/Notifications';

import {
  WarningIcon,
  PrintIcon,
  CheckMarkIcon,
  RightRotateIcon,
  InfoSignIcon,
  WifiIcon,
} from '../../Icons';

import styles from './IconBlock.module.scss';

interface IconBlockProps {
  icon?: string;
  size?: number;
}

export const IconBlock = ({ icon, size = 72 }: IconBlockProps) => {
  if (!icon) {
    return null;
  }

  const modalIconMap: { [key: string]: JSX.Element } = {
    warning: <WarningIcon size={size} />,
    printIcon: <PrintIcon size={size} />,
    checkMark: <CheckMarkIcon size={size} />,
    errorIcon: <ErrorIcon size={size} />,
    rightRotateArrow: <RightRotateIcon size={size} />,
    infoIcon: <InfoSignIcon size={size} />,
    wifiIcon: <WifiIcon size={size} />,
  };

  return (
    <div className={styles.iconPosition}>
      <div className={styles.iconPadding} aria-label={icon.toString()}>
        {modalIconMap[icon]}
      </div>
    </div>
  );
};
